import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const PageUrlGuid=({children})=>{
    const path=useLocation()
    return(
        <div className='page-url-guid'>
            {children}
        </div>
    )
}


export default PageUrlGuid